// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_TgpkT","footer":"index_footer_j9zJc"};